module.exports = __webpack_public_path__ + "static/media/009-camera.77a4979a.svg";